module.exports = __webpack_public_path__ + "static/media/joanna_bui.a011fcc4.png";